 
 
import {   Headers } from '@angular/http';
import { Client } from '../entity/exhibitor';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
 
 
import "rxjs/add/operator/map";
import { Injectable } from '@angular/core';
  
 
 
@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private baseUrl = environment.restApi;
  // private baseUrlOnline = environment.restApiOnline;
  private clientUrl = `${this.baseUrl}participants`;
  constructor(private http:HttpClient ) { }


  findArchives() : Observable<Client[]>{
    return this.http.get<Client[]>(`${this.clientUrl}/findArchives`);
   }
 

   findExhibitors() : Observable<Client[]>{
    return this.http.get<Client[]>(`${this.clientUrl}/findExhibitors`);
   }
   findbyType(type:string) : Observable<Client[]>{
    return this.http.get<Client[]>(`${this.clientUrl}/findbyType/${type}`);
   }
   
   findDelegates() : Observable<Client[]>{
    return this.http.get<Client[]>(`${this.clientUrl}/findDelegates`);
   } 
   printNotification(client:Client,entrer:boolean): any {
    //console.log("printNotificationPdfClient "+client.raisonSocial);
    
  return this.http.get(`${this.baseUrl}reporting`+ '/printNotificationPdf/'+   client.idClient+ "/"+  entrer, { responseType: "blob"})  ;
}
printNotificationMass(clients:Client[],entrer:boolean,isZip:boolean): any {
 
  
return this.http.put(`${this.baseUrl}reporting`+ '/printNotificationMass/'+   entrer+ "/"+  isZip,clients, { responseType: "blob"})  ;
}


private getHeaders1() {
  const headers = new Headers();
  headers.append('Accept', 'application/pdf');
  headers.append('Content-Type', 'application/pdf');
  return headers;
}
private getHeadersZip() {
  const headers = new Headers();
  headers.append('Accept', 'application/x-bzip');
  headers.append('Content-Type', 'application/x-bzip');
  return headers;
}
}
